<template>
  <div>
    <a-table
      :columns="columns"
      :data-source="Object.values(data)"
      :loading="loading"
      :pagination="false"
    >
      <span slot="createdAt" slot-scope="date">{{ formatDate(date) }}</span>
      <span slot="updatedAt" slot-scope="date">{{ formatDate(date) }}</span>
      <span slot="company" slot-scope="text, record">{{
        record.company.name
      }}</span>
      <span slot="agent" slot-scope="text, record">{{ record.user.name }}</span>
      <div slot="actions" slot-scope="text, record" class="row justify-between">
        <a-button
          id="e-v-btn"
          type="primary"
          class="col-5 mr-1"
          data-toggle="modal"
          data-target="#view-data"
          @click="openModal(record)"
        >
          {{ draft ? "Edit" : "View" }}</a-button
        >
        <a-button
          v-if="draft || currentUser.role === 'supervisor'"
          class="col-5 mr-1"
          type="danger"
          @click="showConfirm(record)"
          >{{ actionTitle }}</a-button
        >
      </div>
    </a-table>
    <ModalDelete
      :remove="proceedToDelete"
      :on-confirm="deleteItem"
      :message="comfirmationMessage"
      :loading="loading"
    />
    <a-modal
      :visible="editModalVisible"
      :title="modalTital"
      width="50%"
      :footer="null"
      @cancel="closeModal"
    >
      <edit-item v-if="draft" :item="currentData" :close-modal="closeModal" />
      <item-view v-else :item="currentData" />
    </a-modal>
  </div>
</template>

<script>
import ModalDelete from "../Modals/Confirmation";
import EditItem from "./EditItem";
import ItemView from "./ItemView";
import moment from "moment";
import { isEmpty } from "lodash";
import { mapGetters } from "vuex";
const columns = [
  {
    title: "Client Name",
    dataIndex: "clientName",
    key: "clientName",
  },
  {
    title: "District",
    dataIndex: "district",
    key: "district",
  },
  {
    title: "Sector",
    dataIndex: "sector",
    key: "sector",
  },
  {
    title: "Cell",
    dataIndex: "cell",
    key: "cell",
  },
  {
    title: "Village",
    dataIndex: "village",
    key: "village",
  },
  {
    title: "Created",
    dataIndex: "createdAt",
    key: "createdAt",
    scopedSlots: { customRender: "createdAt" },
    ellipsis: true,
  },
  {
    title: "Last Edit",
    dataIndex: "updatedAt",
    key: "updatedAt",
    scopedSlots: { customRender: "updatedAt" },
    ellipsis: true,
  },
  {
    title: "Company",
    dataIndex: "company",
    key: "company",
    scopedSlots: { customRender: "company" },
    ellipsis: true,
  },
  {
    title: "Agent",
    dataIndex: "agent",
    key: "agent",
    scopedSlots: { customRender: "agent" },
    ellipsis: true,
  },
  {
    title: "Actions",
    dataIndex: "actions",
    key: "actions",
    scopedSlots: { customRender: "actions" },
    width: 200,
  },
];
export default {
  name: "SalesTable",
  components: {
    ModalDelete,
    EditItem,
    ItemView,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    draft: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columns,
      currentData: {},
      editModalVisible: false,
      submitting: false,
    };
  },
  computed: {
    ...mapGetters({ currentUser: "auth/currentUser" }),
    actionTitle() {
      return this.currentUser.role === "supervisor" ? "Revert" : "Delete";
    },
    comfirmationMessage() {
      return this.currentUser.role === "supervisor"
        ? "Are you sure you want to revert this record to draft?"
        : "Are you sure you want to delete this draft?";
    },
    modalTital() {
      return this.draft ? "Edit Sales Details" : "Sales' Details";
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/YY");
    },
    openModal(item) {
      this.currentData = item;
      this.editModalVisible = true;
    },
    closeModal() {
      this.currentData = {};
      this.editModalVisible = false;
    },
    isEmpty(value) {
      return isEmpty(value);
    },
    async deleteItem(id) {
      this.submitting = true;
      try {
        if (this.currentUser.role === "supervisor") {
          await this.$store.dispatch("sales/revertToDraft", id);
        }
        await this.$store.dispatch("sales/deleteSalesItem", id);
      } catch (error) {
        this.$message.error(error.message || error);
      } finally {
        this.submitting = false;
      }
    },
    showConfirm(record) {
      this.$confirm({
        content:
          this.currentUser.role === "supervisor"
            ? "Are you sure you want to revert this record to draft?"
            : "Are you sure you want to delete this draft?",
        onOk: this.deleteItem(record.id),
        onCancel() {},
      });
    },
  },
};
</script>
<style lang="css" scoped>
#e-v-btn {
  padding: 0;
}
#d-btn {
  padding: 0;
}
</style>
